import { motion } from 'framer-motion';
import { MessageCircle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EscapeHatchProps {
  onSkip: () => Promise<void>;
  isLoading: boolean;
}

export function EscapeHatch({ onSkip, isLoading }: EscapeHatchProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="my-6"
    >
      <div className="bg-teal/10 border border-teal/20 rounded-xl p-5">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-full bg-teal/20 flex items-center justify-center flex-shrink-0">
            <MessageCircle className="w-5 h-5 text-teal" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-foreground mb-1">Prefer to talk first?</h4>
            <p className="text-sm text-muted-foreground mb-4">
              No problem! We've saved your info and will reach out within 24 hours to schedule a discovery call.
            </p>
            <Button
              variant="outline"
              onClick={onSkip}
              disabled={isLoading}
              className="border-teal/30 text-teal hover:bg-teal/10 hover:text-teal"
            >
              {isLoading ? (
                <Loader2 className="w-4 h-4 animate-spin mr-2" />
              ) : null}
              Skip questionnaire — just contact me
            </Button>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4 my-6">
        <div className="flex-1 h-px bg-border" />
        <span className="text-xs text-muted-foreground uppercase tracking-wider">OR continue below</span>
        <div className="flex-1 h-px bg-border" />
      </div>
    </motion.div>
  );
}
